import { render, staticRenderFns } from "./EditAnswer.vue?vue&type=template&id=0785531d&scoped=true&"
import script from "./EditAnswer.vue?vue&type=script&lang=js&"
export * from "./EditAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0785531d",
  null
  
)

export default component.exports